import type { ChatConversationListItem, ChatMessage } from './chatHttp.service'

const toDate = (value: Date | string | null | undefined) => {
  if (!value) return value
  return value instanceof Date ? value : new Date(value)
}

export const afterReceivingConversations = (list: ChatConversationListItem[]) => {
  return (list || []).map(item => ({
    ...item,
    lastMessageAt: toDate(item.lastMessageAt) as Date | null,
  }))
}

const normalizeMessage = (message: ChatMessage): ChatMessage => ({
  ...message,
  _created: toDate(message._created) as Date,
  deletedAt: toDate(message.deletedAt as any) as Date | null,
  editedAt: toDate(message.editedAt as any) as Date | null,
  poll: message.poll
    ? {
        ...message.poll,
        _created: toDate(message.poll._created) as Date,
      }
    : message.poll,
  attachments: (message.attachments || []).map(attachment => ({
    ...attachment,
    expiresAt: toDate(attachment.expiresAt) as Date,
    _created: toDate(attachment._created) as Date,
  })),
})

export const afterReceivingMessages = (list: ChatMessage[]) => {
  return (list || []).map(normalizeMessage)
}

export const afterReceivingOneMessage = (message: ChatMessage) => {
  return normalizeMessage(message)
}
